var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rabattBox sub-main" }, [
    _c("div", { staticClass: "warp" }, [
      _c("div", { staticClass: "rabattTit" }, [
        _c("h3", [_vm._v("秒杀专区")]),
        _vm._v(" "),
        _vm.id
          ? _c("div", { staticClass: "countdown" }, [
              _c("div", { staticClass: "countdownTit" }, [_vm._v("本场剩余")]),
              _vm._v(" "),
              _c("div", { staticClass: "timeDown" }, [
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm._f("formatHours")(_vm.time)))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(":")]),
                _vm._v(" "),
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm._f("formatMinutes")(_vm.time)))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(":")]),
                _vm._v(" "),
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm._f("formatSeconds")(_vm.time)))
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.flag
        ? _c(
            "div",
            [
              _vm.id == ""
                ? _c("div", { staticClass: "sort" }, [
                    _c("div", [_vm._v("排序：")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "default",
                        class: _vm.index == "1" ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.defaultSort()
                          }
                        }
                      },
                      [_vm._v("默认")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "price",
                        class: _vm.index == "2" ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.priceSort()
                          }
                        }
                      },
                      [
                        _vm._v("\n            价格\n            "),
                        _c("div", { staticClass: "arr" }, [
                          _c("div", {
                            staticClass: "up",
                            class: _vm.type == 1 ? "low" : ""
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "down",
                            class: _vm.type == 2 ? "high" : ""
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sales",
                        class: _vm.index == "3" ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.salesSort()
                          }
                        }
                      },
                      [
                        _vm._v("\n              销量\n              "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.index !== "3",
                              expression: "index!=='3'"
                            }
                          ],
                          attrs: {
                            src: require("../../../static/image/reduce@2x.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.index == "3" && _vm.volume == 1,
                              expression: "index=='3' && volume==1"
                            }
                          ],
                          attrs: {
                            src: require("../../../static/image/reduce2@2x.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.index == "3" && _vm.volume == 2,
                              expression: "index=='3' && volume==2"
                            }
                          ],
                          attrs: {
                            src: require("../../../static/image/reduce1@2x.png"),
                            alt: ""
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rabattList" },
                _vm._l(_vm.proList, function(item) {
                  return _c(
                    "div",
                    { key: item.productId, staticClass: "item" },
                    [
                      _c("div", { staticClass: "imgBox" }, [
                        _c("img", { attrs: { src: item.image, alt: "" } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "priceBox" }, [
                        _c("h3", [_vm._v(_vm._s(item.productName))]),
                        _vm._v(" "),
                        _c("span", { staticClass: "price" }, [
                          _vm._v("秒杀价：¥" + _vm._s(item.price) + " "),
                          _c("b", [_vm._v("¥" + _vm._s(item.originalPrice))])
                        ]),
                        _vm._v(" "),
                        item.limitNumber
                          ? _c(
                              "div",
                              { staticClass: "begrenzt" },
                              [
                                _c("span", { staticClass: "people" }, [
                                  _vm._v(
                                    "限量" +
                                      _vm._s(item.limitNumber) +
                                      "件/还剩" +
                                      _vm._s(item.limitStockNumber) +
                                      "件"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("el-progress", {
                                  attrs: {
                                    "text-inside": true,
                                    "stroke-width": 10,
                                    percentage:
                                      ((item.limitNumber -
                                        item.limitStockNumber) /
                                        item.limitNumber) *
                                      100,
                                    status: "exception"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.toProductDetail(item)
                              }
                            }
                          },
                          [_vm._v("立即抢购")]
                        )
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("el-pagination", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  background: "",
                  layout: "prev, pager, next, jumper",
                  "page-size": _vm.pageSize,
                  "current-page": _vm.page,
                  total: _vm.total
                },
                on: { "current-change": _vm.changePage }
              })
            ],
            1
          )
        : _c("div", { staticClass: "noproduct" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/noorder@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "fs20 font-color-999" }, [
              _vm._v("该活动没有商品～")
            ])
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1df71343", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1df71343","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/promotions/rabatt.vue
// module id = null
// module chunks = 